import moment from "moment/moment";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { utils, writeFile } from "xlsx";

export const handleFileUpload = (e) => {
  const file = e.target.files[0];

  if (file) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      console.log(jsonData);

      return jsonData
    };
    reader.readAsBinaryString(file);
  }
};


export const handleCopy = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    toast.success('Copied')
  }).catch(err => {
    toast.error('failed to copy')

  });
};


export const extractAttributes = (products) => {
  const attributeMap = {};

  products?.forEach((product) => {
    const attributes = product.attributes || {};

    Object.entries(attributes).forEach(([key, values]) => {
      if (!attributeMap[key]) {
        attributeMap[key] = new Set(); // Use a Set to store unique values
      }

      // Ensure values are always treated as an array
      const valueArray = Array.isArray(values) ? values : [values];
      valueArray.forEach((val) => attributeMap[key].add(val));
    });
  });

  // Convert the Set into an array for the final result
  return Object.entries(attributeMap).map(([key, values]) => ({
    attribute: key,
    values: Array.from(values),
  }));
};


export const exportDataExcel = (data, title) => {
  const worksheet = utils.json_to_sheet(data); // Convert JSON to sheet
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, title);
  writeFile(workbook, `${title}.xlsx`);
}

export const formateDate = (data) => {
  return moment(data).format('DD MMM YYYY')
}



const getBreakQtyDetails = (quantityTable, quantity) => {
  if (!Array.isArray(quantityTable) || quantityTable.length === 0) {
    return { breakQty: 1, unitPrice: 0 };
  }
  const sortedTable = [...quantityTable].sort((a, b) => (b?.breakQty || 0) - (a?.breakQty || 0));
  const matchedTier = sortedTable.find((entry) => quantity >= (entry?.breakQty || 0));
  return matchedTier || sortedTable[0] || { breakQty: 1, unitPrice: 0 };
};

export const stripHtmlTags = (input) => {
  if (!input) return '';
  let str = Array.isArray(input) ? (input[0] || '') : input;
  if (typeof str !== 'string') str = String(str || '');
  return str
    .replace(/<\/(p|div|li|br)>/gi, ' ')
    .replace(/<br\s*[\/]?>/gi, ' ')
    .replace(/<[^>]*>?/gm, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&plusmn;/g, '±')
    .replace(/\s+/g, ' ')
    .trim();
};

export const stripHtml = stripHtmlTags;
